import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0B2039',
    },
    secondary: {
      main: '#326991',
    },
    text: {
      primary: '#000000',
      secondary: '#75787B',
    },
    background: {
      default: '#f4f6f8',
      paper: '#ffffff',
    }
  },
  typography: {
    fontFamily: 'Eurostile, Arial, sans-serif',
  },
});

export default theme;